import { Badge as MuiBadge, BadgeProps } from '@mui/material';

interface IBadge extends BadgeProps {
  badgeContent: number;
  maxCount?: number;
}

export const Badge = (props: IBadge) => {
  const { badgeContent, maxCount, ...other } = props;

  let marginLeft = '2px';
  if (badgeContent) {
    if (badgeContent >= 10 && badgeContent <= 99) {
      marginLeft = '-2px';
    } else if (badgeContent >= 100) {
      marginLeft = '-8px';
    }
  }

  return (
    <MuiBadge
      badgeContent={maxCount && badgeContent > maxCount ? `${maxCount}+` : badgeContent}
      sx={{
        '& .MuiBadge-badge': {
          marginLeft,
          color: 'text.main',
          backgroundColor: 'error.main',
        },
      }}
      {...other}
    />
  );
};
